import { InjectionToken, Type } from '@angular/core';
import { Observable } from 'rxjs';
import {
  DrupalIdentifier,
  DrupalNode,
  DrupalTerm,
  Media,
} from '@nx-icilalune/drupal-types';

export const DATA_ACCESS_BASE_URL = new InjectionToken<string>(
  'DATA_ACCESS_BASE_URL'
);

export const MODEL_CLASS_MAP = new InjectionToken<Map<string, Type<any>>>(
  'MODEL_CLASS_MAP'
);

export const JSON_API_LANGUAGE = new InjectionToken<Observable<string>>(
  'JSON_API_LANGUAGE'
);

export const CURRENT_LANGUAGE = new InjectionToken<Observable<string>>(
  'CURRENT_LANGUAGE'
);

export const AVAILABLE_LANGUAGES = new InjectionToken<string[]>(
  'AVAILABLE_LANGUAGES'
);

export const ALL_DRUPAL_NODES = new InjectionToken<Observable<DrupalNode[]>>(
  'ALL_DRUPAL_NODES'
);

export const ALL_DRUPAL_MEDIA = new InjectionToken<Observable<Media[]>>(
  'ALL_DRUPAL_MEDIA'
);

export const ALL_DRUPAL_TERMS = new InjectionToken<Observable<DrupalTerm[]>>(
  'ALL_DRUPAL_TERMS'
);

export const ALL_DRUPAL_DATA = new InjectionToken<
  Observable<DrupalIdentifier[]>
>('ALL_DRUPAL_DATA');
